export default __webpack_public_path__ + "static/media/ScheduleSquare.091fe53f.svg";